import axios from "../../privateApi";

interface CheckoutSessionOptions {
  priceId?: string;
  discountId?: string;
  freeTrial?: number;
  groupId?: string;
}

export const createCheckoutSession = async ({
  priceId,
  discountId,
  freeTrial,
  groupId,
}: CheckoutSessionOptions) => {
  const body = {
    priceId,
    discountId,
    freeTrial,
    refId: window.Rewardful?.referral,
    ...(groupId && { groupId }),
  };

  return axios
    .post("/payments/create-checkout-session", body)
    .then((response) => {
      if (response.data.status === 303) {
        window.location.href = response.data.url;
      }
    });
};
